// 各頁共用的 CSS（從 home/*.js 抽出，每頁皆相同）
import "@/css/share/_fonts.scss";
import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_lightbox.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";
import "@/css/share/components/_footer_sponsor.scss";
import "@/css/share/components/_fastlink.scss";
import "@/css/share/components/_input.scss";
import "@/css/share/components/_maintitle.scss";

// swiper CSS 體積小（gzip ~3KB），直接靜態併入 common.min.css，
// 省去 CSS-only 動態 import 產生的空 JS stub 與額外請求
import "swiper/css";

// 各頁共用元件（原本重複散在多個 home/*.js，集中於此避免重複打包）
// 註: _swiper.scss(自訂覆蓋) 需置於 swiper/css(函式庫) 之後
import "@/css/share/components/_swiper.scss";
import "@/css/share/components/_breadcrumbs.scss";
import "@/css/share/components/_top_cate.scss";
import "@/css/share/components/_tpl.scss";
import "@/css/share/components/_sidenav.scss";
import "@/css/share/components/_content.scss";
import "@/css/share/components/_backbtn.scss";
import "@/css/share/components/_sec_title.scss";
import "@/css/share/components/_button.scss";
import "@/css/share/components/_form_row.scss";
import "@/css/share/components/_list.scss";
import "@/css/share/components/_list_item.scss";
import "@/css/share/components/_list_swiper.scss";
import "@/css/share/components/_bottom_list.scss";
import "@/css/share/components/_pagination.scss";
import "@/css/share/components/_tab_row.scss";
import "@/css/share/components/_hashtag.scss";
import "@/css/share/components/_icon_arrow.scss";
import "@/css/share/components/_gallery.scss";
import "@/css/share/components/_rating.scss";
import "@/css/share/components/_info_list.scss";
import "@/css/share/components/_film_maintitle.scss";
import "@/css/share/components/_search_result.scss";
import "@/css/share/components/_ind_search.scss";
import "@/css/share/components/_ck_editor.scss";

// fontawesome（各頁共用）：完整 icon 集約 200KB，維持非阻塞 prefetch，
// 避免併入 render-blocking 的 common.min.css 而拖慢 FCP。
// 以相同 webpackChunkName 將 5 個檔案合併成單一 chunk，減少請求數
import(/* webpackChunkName: "fontawesome", webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackChunkName: "fontawesome", webpackPrefetch: true */ "@/lib/fontawesome/css/brands.min.css");
import(/* webpackChunkName: "fontawesome", webpackPrefetch: true */ "@/lib/fontawesome/css/solid.min.css");
import(/* webpackChunkName: "fontawesome", webpackPrefetch: true */ "@/lib/fontawesome/css/regular.min.css");
import(/* webpackChunkName: "fontawesome", webpackPrefetch: true */ "@/lib/fontawesome/css/light.min.css");
